require('./myProfileSettingsView.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
const classNames = require('classnames');
const trim = require('lodash/string/trim');
const PropTypes = require('prop-types');

// @actions
const profileEditorSettingsActions = require('actions/profileEditorSettings');
const cardsActions = require('actions/getMyCards');
const accountsActions = require('actions/getAccounts');
const { requestPublicInformation } = require('actions/myGlobalPosition');

// @commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { OKCover } = require('commonsComponents/OKCover');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');

// @components
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const SettingsSummary = require('components/myProfile/settingsSummary/settingsSummary');
const ProfileSettingsSummary = require('components/myProfile/profileSettingsSummary/profileSettingsSummary');

import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ constants
const {
    CARD_ECARD,
    CARD_CREDIT,
    MY_PROFILE_ACCOUNT,
    WALLETS,
    TYPE_FUTURES,
    FUNDS,
    PLANS,
    FILTERS_VALID,
    MORTGAGES,
    LOANS,
    SAVINGS
} = require('constants/index');
const {
    CREDIT: CREDIT_FLAG,
    INVESTMENTS: INVESTMENTS_FLAG,
    TYPE_FUNDS: TYPE_FUNDS_FLAG,
    TYPE_PLANS: TYPE_PLANS_FLAG,
    LOANS_MORTGAGES: LOANS_MORTGAGES_FLAG,
    SAVINGS: SAVINGS_FLAG
} = require('constants/flagBasedFeatures');
const infoIcon = require('assets/images/icon-info-blue.svg'); //@hardcoded: replace Icon placeholder
const { isMortgage } = require('utilities/APIParsingHelper');
const { OKLink } = require('commonsComponents/OKLink');


class MyProfileSettingsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            preferenceAccounts: this.props.immAccounts.get('byOrder')
        };
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCustomAccountSettings = this.handleCustomAccountSettings.bind(this);
        this.handleSaveAccountsClick = this.handleSaveAccountsClick.bind(this);
        this.handleCustomCardSettings = this.handleCustomCardSettings.bind(this);
        this.handleCustomWalletSettings = this.handleCustomWalletSettings.bind(this);
        this.handleCustomFutureSettings = this.handleCustomFutureSettings.bind(this);
        this.handleCustomFundSettings = this.handleCustomFundSettings.bind(this);
        this.handleCustomPlanSettings = this.handleCustomPlanSettings.bind(this);
        this.handleOnClickLoanSettings = this.handleOnClickLoanSettings.bind(this);
        this.handleUpArrowClicked = this.handleUpArrowClicked.bind(this);
        this.handleBottomArrowClicked = this.handleBottomArrowClicked.bind(this);
        this.handleSaveButtonClick = this.handleSaveButtonClick.bind(this);
        this.handleAccountPreferences = this.handleAccountPreferences.bind(this);
    }

    componentDidMount() {
        this.requestData();
    }

    getDataToRenderByType(type) {
        const { immAccounts, immWallets, immFutures, immFunds, immPlans, immSavings } = this.props;
        const cardTypes = {
            credit: 'profileSettings-settingCreditCardTitle',
            ecard: 'profileSettings-settingEcardTitle'
        };

        let dataToRender = {};

        dataToRender.iconClass = classNames('settings-view__icon icon', {
            'rebrand-accounts': type === MY_PROFILE_ACCOUNT,
            'rebrand-credit-card': type === CARD_CREDIT,
            'rebrand-ecard': type === CARD_ECARD,
            'rebrand-wallets': type === WALLETS,
            'rebrand-investments': type === TYPE_FUTURES,
            'rebrand-funds': type === FUNDS,
            'rebrand-plans': type === PLANS,
            'rebrand-mortgages': type === MORTGAGES,
            'rebrand-loans': type === LOANS,
            'rebrand-savings': type === SAVINGS
        });

        if (type === MY_PROFILE_ACCOUNT) {
            dataToRender.body = this.buildAccounts();
            dataToRender.header = `${formatText('profileSettings-accountTitle')} (${immAccounts.get('byOrder').size})`;
        } else if (type === WALLETS) {
            dataToRender.body = this.buildWallets().toList();
            dataToRender.header = `${formatText('profileSettings-walletTitle')} (${immWallets.size})`;
        } else if (type === TYPE_FUTURES) {
            dataToRender.body = this.buildFutures();
            dataToRender.header = `${formatText('profileSettings-futuresTitle')} (${immFutures.size})`;
        } else if (type === FUNDS) {
            dataToRender.body = this.buildFunds();
            dataToRender.header = `${formatText('profileSettings-fundsTitle')} (${immFunds.size})`;
        } else if (type === PLANS) {
            dataToRender.body = this.buildPlans();
            dataToRender.header = `${formatText('profileSettings-plansTitle')} (${immPlans.size})`;
        } else if (type === MORTGAGES) {
            dataToRender.body = this.buildMortgages().toList();
            dataToRender.header = `${formatText('profileSettings-mortgagesTitle')} (${this.loansWithBalanceBiggerThanCero(true, true)})`;
        } else if (type === LOANS) {
            dataToRender.body = this.buildLoans().toList();
            dataToRender.header = `${formatText('profileSettings-loansTitle')} (${this.loansWithBalanceBiggerThanCero(false, true)})`;
        } else if (type === SAVINGS) {
            dataToRender.body = this.buildSavings();
            dataToRender.header = `${formatText('profileSettings-savingsTitle')} (${immSavings.size})`;
        } else {
            dataToRender.body = this.buildCards(type);
            dataToRender.header = `${formatText(cardTypes[type])} (${this.getTotalCardsByType(type)})`;
        }

        return dataToRender;
    }

    getTotalCardsByType(type) {
        const { immCards } = this.props;
        const immCardsList = immCards.get('byOrder');
        const immCardsById = immCards.get('byId');

        const filteredImmCardsList = immCardsList.filter(cardId => {
            const immCard = immCardsById.get(cardId);
            return immCard.get('type') === type && immCard.get('visibleinPG');
        });

        return filteredImmCardsList.size;
    }

    handleSaveButtonClick() {
        const immAccountsById = this.props.immAccounts.get('byId');
        let sortedAccountInfo = [];
        this.state.preferenceAccounts && this.state.preferenceAccounts.map(account => {
            const immAccount = immAccountsById.get(account);
            sortedAccountInfo.push(immAccount.get('newProduct') + immAccount.get('newContractNumber'));
        });
        this.handleSaveAccountsClick(sortedAccountInfo);
    }

    buildAccordion(type) {
        let dataToRender = this.getDataToRenderByType(type);

        return (
            <Accordion customClassName="settings-view__accordion" hasLargeContent>
                <AccordionHeader name="AccordionHeader">
                    <div className="settings-view__accordion-header">
                        <i className={dataToRender.iconClass} />
                        <h4 className="settings-view__accordion-title">
                            {dataToRender.header}
                        </h4>
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="settings-view__accordion-body">
                        {dataToRender.body}
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    swapItems(items, firstIndex, secondIndex) {
        return items.map(function (element, index) {
            if (index === firstIndex) return items.get(secondIndex);
            else if (index === secondIndex) return items.get(firstIndex);
            else return element;
        });
    }

    handleAccountPreferences(sourceIndex, destinationIndex) {
        this.setState((prevState) => {
            const { preferenceAccounts } = prevState;
            const preferenceAccountsCopy = this.swapItems(preferenceAccounts, sourceIndex, destinationIndex);
            return {
                preferenceAccounts: preferenceAccountsCopy
            }
        }, () => {
            this.handleSaveButtonClick();
        })
    }

    handleUpArrowClicked(index) {
        this.handleAccountPreferences(index, index - 1);
    }

    handleBottomArrowClicked(index) {
        this.handleAccountPreferences(index, index + 1);
    }

    buildAccounts() {
        const { immAccounts } = this.props;
        const { preferenceAccounts } = this.state;
        const immAccountsById = immAccounts.get('byId');
        let content;
        content = preferenceAccounts.map((account, index) => {
            const immAccount = immAccountsById.get(account);
            const accountId = immAccount.get('accountId');
            const alias = immAccount.get('isAliasUpdating')
                ? toCamelCase(immAccount.get('aliasTentative'))
                : toCamelCase(immAccount.get('alias'));
            const checked = immAccount.get('filters').get('valid');
            const iban = immAccount.get('iban');
            const ibanFormatted = getLastNChars(iban);
            const subTitle = immAccount.get('catalogData').get('subtype') || '';
            const title = alias || '';
            const smallTitle = ibanFormatted || '';

            let handleOnClickAccountSettings = checked => {
                this.handleCustomAccountSettings(accountId, checked);
            };

            return (
                <ProfileSettingsSummary
                    key={index}
                    numberOfAccounts={preferenceAccounts.size}
                    index={index}
                    title={title}
                    smallTitle={smallTitle}
                    subTitle={subTitle}
                    checked={checked}
                    handleClick={handleOnClickAccountSettings}
                    onUpArrowClicked={this.handleUpArrowClicked}
                    onBottomArrowClicked={this.handleBottomArrowClicked}
                />
            );
        });
        return content;
    }

    buildCards(type) {
        const { immCards } = this.props;
        const immCardsList = immCards.get('byOrder');
        const immCardsById = immCards.get('byId');

        return immCardsList.map((card, index) => {
            const immCard = immCardsById.get(card);

            if (immCard.get('type') === type && immCard.get('visibleinPG')) {
                const cardId = immCard.get('cardId');
                const cardNumber = getLastNChars(immCard.get('number'), 4);
                const checked = immCard.get('filters').get('valid');
                const subTitle = immCard.get('subtype');
                const title = immCard.get('alias').get('current') || '';
                const smallTitle = cardNumber || '';
                let handleOnClickCardSettings = checked => {
                    this.handleCustomCardSettings(cardId, checked);
                };

                return (
                    <SettingsSummary
                        key={index}
                        title={title}
                        smallTitle={smallTitle}
                        subTitle={subTitle}
                        checked={checked}
                        handleClick={handleOnClickCardSettings}
                    />
                );
            }
        });
    }

    buildFunds() {
        const { immFunds } = this.props;
        return immFunds.map((immFund, index) => {
            const alias = trim(immFund.get('descripcion'));
            const checked = immFund.getIn(['filtros', 'valido']) === FILTERS_VALID ? true : false;
            const title = alias;
            let handleOnClickFundSettings = checked => {
                this.handleCustomFundSettings(index, checked);
            };

            return (
                <SettingsSummary
                    key={index}
                    title={title}
                    subTitle=""
                    checked={checked}
                    handleClick={handleOnClickFundSettings}
                />
            );
        });
    }

    buildFutures() {
        const { immFutures } = this.props;
        return immFutures.map((immFuture, index) => {
            const futureId = immFuture.getIn(['cnuevo', 'numerodecontrato']);
            const alias = trim(immFuture.get('descripcion'));
            const checked = immFuture.getIn(['filtros', 'valido']) === FILTERS_VALID ? true : false;
            const title = alias || '';
            const smallTitle = '...' + getLastNChars(futureId) || '';
            let handleOnClickFutureSettings = checked => {
                this.handleCustomFutureSettings(index, checked);
            };

            return (
                <SettingsSummary
                    key={futureId}
                    title={title}
                    smallTitle={smallTitle}
                    checked={checked}
                    handleClick={handleOnClickFutureSettings}
                />
            );
        });
    }

    buildLoans() {
        return this.loansWithBalanceBiggerThanCero().map((account, index) => {
            const immMortgage = account;
            const mortgageId = immMortgage.get('contractNumber');
            const alias = immMortgage.get('alias');
            const checked = immMortgage.get('filters').get('valid');
            const title = alias;
            let handleOnClickLoanSettings = checked => {
                this.handleOnClickLoanSettings(index, checked);
            };

            return (
                <SettingsSummary
                    key={mortgageId}
                    title={title}
                    subTitle=""
                    checked={checked}
                    handleClick={handleOnClickLoanSettings}
                />
            );
        });
    }

    buildMortgages() {
        return this.loansWithBalanceBiggerThanCero(true).map((account, index) => {
            const immMortgage = account;
            const mortgageId = immMortgage.get('contractNumber');
            const alias = immMortgage.get('alias');
            const checked = immMortgage.get('filters').get('valid');
            const title = alias;
            let handleOnClickLoanSettings = checked => {
                this.handleOnClickLoanSettings(index, checked);
            };

            return (
                <SettingsSummary
                    key={mortgageId}
                    title={title}
                    subTitle=""
                    checked={checked}
                    handleClick={handleOnClickLoanSettings}
                />
            );
        });
    }

    buildPlans() {
        const { immPlans } = this.props;
        return immPlans.map((immPlan, index) => {
            const planId = immPlan.getIn(['contrato', 'numerodecontrato']);
            const alias = trim(immPlan.get('descripcion'));
            const checked = immPlan.getIn(['filtros', 'valido']) === FILTERS_VALID ? true : false;
            const title = alias;
            let handleOnClickPlanSettings = checked => {
                this.handleCustomPlanSettings(index, checked);
            };

            return (
                <SettingsSummary
                    key={planId}
                    title={title}
                    subTitle=""
                    checked={checked}
                    handleClick={handleOnClickPlanSettings}
                />
            );
        });
    }

    buildSavings() {
        const { immSavings } = this.props;
        return immSavings.map((immSaving, index) => {
            const alias = immSaving.get('description');
            const checked = immSaving.get('valid');
            const title = alias;
            const id = immSaving.get('id');
            const handleOnClickSavingSettings = checked => {
                this.handleCustomSavingSettings(id, checked);
            };
            return (
                <SettingsSummary
                    key={index}
                    title={title}
                    subTitle=""
                    checked={checked}
                    handleClick={handleOnClickSavingSettings}
                />
            );
        });
    }

    buildWallets() {
        const { immWallets } = this.props;
        return immWallets.map((immWallet, index) => {
            const walletId = immWallet.get('accountNumber');
            const alias = trim(immWallet.get('name'));
            const checked = immWallet.getIn(['filtros', 'valido']) === FILTERS_VALID ? true : false;
            const title = alias || '';
            const smallTitle = '...' + getLastNChars(walletId) || '';
            let handleOnClickWalletSettings = checked => {
                this.handleCustomWalletSettings(index, checked);
            };

            return (
                <SettingsSummary
                    key={walletId}
                    title={title}
                    smallTitle={smallTitle}
                    subTitle=""
                    checked={checked}
                    handleClick={handleOnClickWalletSettings}
                />
            );
        });
    }

    handleSaveAccountsClick(collection) {
        this.props.postAccountPreference(collection);
    }
    handleCustomAccountSettings(accountId, checked) {
        this.props.postFilterCustomAccounts(accountId, checked);
    }

    handleCustomCardSettings(cardId, checked) {
        this.props.postFilterCustomCards(cardId, checked);
    }

    handleCustomFundSettings(fundId, checked) {
        this.props.postFilterCustomFunds(fundId, checked);
    }

    handleCustomFutureSettings(futureId, checked) {
        this.props.postFilterCustomFutures(futureId, checked);
    }

    handleCustomPlanSettings(planId, checked) {
        this.props.postFilterCustomPlans(planId, checked);
    }

    handleCustomSavingSettings(savingId, checked) {
        this.props.postFilterCustomSavings(savingId, checked);
    }

    handleCustomWalletSettings(walletId, checked) {
        this.props.postFilterCustomWallets(walletId, checked);
    }

    handleOnClickLoanSettings(loanId, checked) {
        this.props.postFilterCustomLoans(loanId, checked);
    }

    // Use this function to get a list of loans/mortgages depending on the first parameter
    // or only its count depending on the second parameter.
    loansWithBalanceBiggerThanCero(mortgageType = false, returnCount = false) {
        const loans = this.props.immLoans.get('byId').filter(loan => {
            const isMortgageLoan = isMortgage(loan.get('newProduct'), loan.get('productSubType'), loan.get('productStandard'));
            const isRequestedType = mortgageType ? isMortgageLoan : !isMortgageLoan;
            return isRequestedType && loan.getIn(['balance', 'amount']) !== 0; // Adding amount validation to match what it's shown on GP
        });
        return returnCount ? loans.size : loans;
    }

    requestData() {
        const { requestCards, requestAccounts } = this.props;
        requestCards();
        requestAccounts();
    }

    render() {
        const {
            immAccounts,
            immFunds,
            immFutures,
            immPlans,
            immSavings,
            immWallets,
        } = this.props;

        const boxTitle = formatText('profileSettings-boxTitle');
        const titleHeader = formatText('profileSettings-titleHeader');
        const accounts = (immAccounts.get('byOrder').size) ? this.buildAccordion(MY_PROFILE_ACCOUNT) : null;
        const wallets = (immWallets.size) ? this.buildAccordion(WALLETS) : null;
        const futures = (immFutures.size) ? this.buildAccordion(TYPE_FUTURES) : null;
        const funds = (immFunds.size) ? this.buildAccordion(FUNDS) : null;
        const plans = (immPlans.size) ? this.buildAccordion(PLANS) : null;
        const mortgages = this.loansWithBalanceBiggerThanCero(true, true) ? this.buildAccordion(MORTGAGES) : null;
        const loans = this.loansWithBalanceBiggerThanCero(false, true) ? this.buildAccordion(LOANS) : null;
        const credit = (this.getTotalCardsByType(CARD_CREDIT)) ? this.buildAccordion(CARD_CREDIT) : null;
        const ecard = (this.getTotalCardsByType(CARD_ECARD)) ? this.buildAccordion(CARD_ECARD) : null;
        const savings = (immSavings.size) ? this.buildAccordion(SAVINGS) : null;
        const globalPositionUrl = '/myprofile/global/';
        const subtitle =
            accounts || ecard || credit || wallets || funds || plans || savings
                ? 'profileSettings-settingSubtitle'
                : 'profileSettings-emptySubtitle';
        const boxBody = (
            <div>
                <div className="settings-view__info-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <ul className="contact-info-box__list">
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="profileSettings-content1"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="profileSettings-content2"
                        />
                    </li>
                    <li className="contact-info-box__list-item">
                        <FormattedText
                            className="contact-info-box__list-item-value"
                            value="profileSettings-content3"
                        />
                    </li>
                </ul>
            </div>
        );

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="pg" customClass="col-xs-12">
                            <OKHeaderLanding title={titleHeader} />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-positive">
                            {/* >> CONTENT DUPLICATED: REF-01 */}
                            <div className="col-xs-12 hidden-md hidden-lg grid-view--fix-cell-separation-bottom">
                                <ContactInfoBox boxTitle={boxTitle} boxBody={boxBody} icon={infoIcon} customClass="settings-view__no-limits" />
                            </div>
                            {/* CONTENT DUPLICATED: REF-01 << */}
                            <div className="col-xs-12 col-md-8">
                                <div className="settings-view__box-personal-data-container">
                                    <div className="settings-view__box-header">
                                        <h2 className="settings-view__box-header--title">
                                            <FormattedText value="profileSettings-settingTitle" />
                                        </h2>
                                        <p className="settings-view__box-header--subtitle">
                                            <FormattedText value={subtitle} />
                                        </p>
                                    </div>
                                    {accounts}
                                    <FeatureTogglingRender notAllowedProductKey={CREDIT_FLAG} >
                                        {credit}
                                    </FeatureTogglingRender>
                                    {ecard}
                                    <FeatureTogglingRender notAllowedProductKey={INVESTMENTS_FLAG} >
                                        {wallets}
                                        {futures}
                                    </FeatureTogglingRender>
                                    <FeatureTogglingRender notAllowedProductKey={TYPE_FUNDS_FLAG} >
                                        {funds}
                                    </FeatureTogglingRender>
                                    <FeatureTogglingRender notAllowedProductKey={TYPE_PLANS_FLAG} >
                                        {plans}
                                    </FeatureTogglingRender>
                                    <FeatureTogglingRender notAllowedProductKey={LOANS_MORTGAGES_FLAG} >
                                        {loans}
                                        {mortgages}
                                    </FeatureTogglingRender>
                                    <FeatureTogglingRender notAllowedProductKey={SAVINGS_FLAG} >
                                        {savings}
                                    </FeatureTogglingRender>
                                    <div className="settings-view__box-bottom-link">
                                        <OKLink modifier="complementary" to={globalPositionUrl}>
                                            <FormattedText value="profileSettings-settingGlobalPositionLink" />
                                        </OKLink>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    {/* >> REF-01 */}
                                    <div className="hidden-xs hidden-sm col-md-12 grid-view--variable-cell-separation">
                                        <ContactInfoBox boxTitle={boxTitle} boxBody={boxBody} icon={infoIcon} customClass="settings-view__no-limits" />
                                    </div>
                                    {/* REF-01 << */}
                                    <div className="col-xs-12 grid-view--fix-cell-separation">
                                        <CommercialAds path="settings" type="banner-a" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MyProfileSettingsView.propTypes = {
    immCards: PropTypes.object,
    immAccounts: PropTypes.object,
    immWallets: PropTypes.object,
    immFutures: PropTypes.object,
    immFunds: PropTypes.object,
    immPlans: PropTypes.object,
    immLoans: PropTypes.object,
    immSavings: PropTypes.object,
    postFilterCustomAccounts: PropTypes.func,
    postAccountPreference: PropTypes.func,
    postFilterCustomCards: PropTypes.func,
    postFilterCustomWallets: PropTypes.func,
    postFilterCustomFutures: PropTypes.func,
    postFilterCustomFunds: PropTypes.func,
    postFilterCustomPlans: PropTypes.func,
    postFilterCustomLoans: PropTypes.func,
    postFilterCustomSavings: PropTypes.func,
    requestAccounts: PropTypes.func,
    requestCards: PropTypes.func,
    requestPublicInformation: PropTypes.func.isRequired
};

module.exports.constructor = MyProfileSettingsView;
module.exports.MyProfileSettingsView = connect(
    state => ({
        immCards: state.cards,
        immAccounts: state.accounts,
        immWallets: state.brokerWallets.get('walletList'),
        immFutures: state.brokerWallets.get('futuresList'),
        immFunds: state.brokerWallets.get('fundsList'),
        immPlans: state.brokerWallets.get('plansList'),
        immLoans: state.loans,
        immSavings: state.globalPosition.getIn(['savings', 'allSavings'])
    }),
    {
        postFilterCustomAccounts: profileEditorSettingsActions.postFilterCustomAccounts,
        postAccountPreference: profileEditorSettingsActions.postAccountPreference,
        postFilterCustomCards: profileEditorSettingsActions.postFilterCustomCards,
        postFilterCustomWallets: profileEditorSettingsActions.postFilterCustomWallets,
        postFilterCustomFutures: profileEditorSettingsActions.postFilterCustomFutures,
        postFilterCustomFunds: profileEditorSettingsActions.postFilterCustomFunds,
        postFilterCustomPlans: profileEditorSettingsActions.postFilterCustomPlans,
        postFilterCustomLoans: profileEditorSettingsActions.postFilterCustomLoans,
        postFilterCustomSavings: profileEditorSettingsActions.postFilterCustomSavings,
        requestAccounts: accountsActions.requestAccounts,
        requestCards: cardsActions.requestCards,
        requestPublicInformation
    }
)(MyProfileSettingsView);
